import Card from "../ui/Card";
import Image from "../ui/Image";
import { MapPin } from "lucide-react";

import { formatBudget, priceRangeLabel } from "../../hooks/commonHooks";

function getTitle(property) {
  return property?.title || property?.name || "Untitled Property";
}

function getLocation(property) {
  return [property?.city, property?.area].filter(Boolean).join(", ") || "—";
}

function getPrice(property) {
  return priceRangeLabel(
    formatBudget(property?.min_budget),
    formatBudget(property?.max_budget),
    property?.price_range,
  );
}

export default function PropertySummaryCard({ property, agentName, onClick }) {
  const title = getTitle(property);
  const isActive = property?.is_active;

  return (
    <Card
      className="property-summary-card m-0 p-2 cursor-pointer"
      onClick={() => onClick?.(property)}
    >
      <div className="d-flex gap-2 align-center">
        <Image
          src={typeof property?.image_url === "string" ? property.image_url : null}
          alt={title}
          width={64}
          height={64}
          className="property-summary-thumb"
        />

        <div className="property-summary-body">
          <div className="d-flex justify-between align-center gap-2">
            <h4 className="property-title m-0">{title}</h4>
            <span className={`status-badge ${isActive ? "active" : "inactive"}`}>
              {isActive ? "Active" : "Inactive"}
            </span>
          </div>

          <div className="property-item mt-1">
            <MapPin size={14} />
            <span>{getLocation(property)}</span>
          </div>

          <div className="d-flex justify-between text-sm mt-1">
            {agentName ? (
              <span className="text-muted">{agentName}</span>
            ) : (
              <span />
            )}
            <span className="text-primary">{getPrice(property)}</span>
          </div>
        </div>
      </div>
    </Card>
  );
}

export { getTitle, getLocation, getPrice };
